"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAgentConnectionStatus = void 0;
const react_1 = require("react");
const platform_sdk_1 = require("@pureweb/platform-sdk");
function useAgentConnectionStatus(platform) {
    const [agentConnectionStatus, setAgentConnectionStatus] = react_1.useState(platform_sdk_1.AgentConnectionStatus.INITIALIZING);
    react_1.useEffect(() => {
        if (!platform.agent) {
            return;
        }
        platform.agent.onConnection((state) => setAgentConnectionStatus(state));
    }, [platform.agent]);
    return [agentConnectionStatus];
}
exports.useAgentConnectionStatus = useAgentConnectionStatus;
//# sourceMappingURL=AgentConnectionStatusHook.js.map